Vue.component('example-component', require('./ExampleComponent.vue').default);
Vue.component('nippou-day', require('./NippouDayComponent.vue').default);
Vue.component('nippou-component', require('./NippouComponent.vue').default);
Vue.component('nippou-chat', require('./Nippou/ChatComponent.vue').default);
Vue.component('date-component', require('./DateComponent.vue').default);
Vue.component('group-day-nippou-selector', require('./GroupDayNippouSelector.vue').default);
Vue.component('nippou-item-component', require('./NippouItemComponent.vue').default);
Vue.component('nippou-review-component', require('./NippouReviewComponent.vue').default);
Vue.component('activity-selector', require('./ActivitySelector.vue').default);
Vue.component('file-upload', require('./FileUploadComponent.vue').default);
Vue.component('comment', require('./CommentComponent.vue').default);
Vue.component('collapsible-checkbox', require('./CollapsibleComponent.vue').default);
Vue.component('zangyou-component', require('./ZangyouComponent.vue').default);
Vue.component('working-hours-report', require('./WorkingHoursReportComponent').default);